import * as React from 'react'
import Alert from '@mui/material/Alert'
import { Scrollbar } from '@workwave-tidal/core/components'
import { Form, useFormikContext } from 'formik'
import { FormContents } from '../FormContents'
import { ENTITY_TYPES } from '@sales-center/common'
import useTheme from '@mui/material/styles/useTheme'
import { ISaveServicesForLaterFormModel } from '../FormContents/typings'
import { Props as DialogProps } from '../SaveServicesForLaterDialog'
import { useScrollToFieldError } from '@user/components/Formik/ScrollToFieldError/useScrollToFieldError'
import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'

type Props = Pick<
  DialogProps,
  | 'disabled'
  | 'loading'
  | 'localMode'
  | 'serviceFrequencies'
  | 'serviceLocations'
> & {
  onClose: () => void
}

export function SaveServicesForLaterForm(props: Props) {
  const { onClose } = props
  const theme = useTheme()
  const { handleSubmit } = useFormikContext<ISaveServicesForLaterFormModel>()

  useScrollToFieldError()

  return (
    <Form
      noValidate
      onSubmit={handleSubmit}
      style={{ display: 'flex', backgroundColor: '#f5f5f5' }}
    >
      <Stack
        direction="column"
        flexGrow={1}
        sx={{
          width: '600px',
        }}
      >
        <Scrollbar testId="scrollbar">
          <Stack
            direction="column"
            sx={{
              flexGrow: 1,
              padding: theme.spacing(2),
            }}
          >
            <Alert severity="info">
              Split service(s) into a New Opportunity. This helps when saving
              services to sell at a later date.{' '}
              <strong>You must leave at least one service.</strong>
            </Alert>

            <Box>
              <FormContents {...props} entityType={ENTITY_TYPES.Opportunity} />
            </Box>
          </Stack>
        </Scrollbar>

        <Stack
          alignContent="end"
          direction="row"
          sx={{ borderTop: 'solid 1px #ddd', padding: theme.spacing(1) }}
          justifyContent="flex-end"
          spacing={theme.spacing(2)}
        >
          <Button onClick={onClose} variant="text">
            Cancel
          </Button>
          <Button type="submit" variant="contained">
            Create New Opportunity
          </Button>
        </Stack>
      </Stack>
    </Form>
  )
}
